(function(){
    'use strict';

    angular
        .module('elogbooks')
        .config(registerRoutes);

    function registerRoutes($stateProvider) {

        $stateProvider
            .state('email', {
                abstract: true,
                template: '<ui-view/>'
            })
            .state('email.verification', {
                url: "/email-verification",
                templateUrl: '/modules/common/email-verification/email-verification.html',
                controller: 'EmailVerificationController',
                controllerAs: 'vm',
                resolve: {
                    rootResponse: function (apiClient) {
                        return apiClient.get('/');
                    },
                    emailVerficationResponse: (rootResponse, $state, $window) => {
                        if (
                            rootResponse.getLink('verify-email') == null ||
                            $window.localStorage.getItem('userEmail') == null
                        ) {
                            return $state.go('dashboard.user.dashboard');
                        }
                    }
                }
            });
    }
})();
